module.exports = __webpack_public_path__ + "static/media/one.8f66e22d.jpg";